<template>
  <v-row>
    <v-col md="12">
      <v-container fluid>
        <!-- Name -->
        <query-input-card
          title="Query Name"
          description="Name of this Datasource"
          category="name"
          :canRemove="false"
        >
          <v-text-field v-model="queryName" :rules="vruleFieldRequired" required></v-text-field>
        </query-input-card>

        <!-- Dealer -->
        <!-- Must use v-show rather than v-if for correct behavior with dealers -->
        <query-input-card
          v-show="!dealerScopedView"
          title="Dealer"
          description="Filter on this Dealer"
          category="name"
          :canRemove="false"
        >
          <dealer-select
            v-model="dealerId"
            :dealer_id="dealerId"
            required
            :rules="vruleFieldRequired"
          />
        </query-input-card>

        <!-- Selected Query Params... -->
        <query-input-card
          v-for="(queryParam, queryParamIndex) in selectedQueryParams"
          v-bind:key="queryParam.name"
          :title="queryParam.title"
          :description="queryParam.description"
          :category="queryParam.category"
          :help="queryParam.help"
          v-on:remove="notifyRemovalOf(queryParam.name)"
        >
          <template v-for="(queryField, fieldIndex) in queryParam.query_fields">
            <component
              v-bind:is="inputTypeView(queryField)"
              v-bind:key="queryParam.name + queryField + fieldIndex"
              v-model="selectedQueryParams[queryParamIndex].query_fields[fieldIndex]"
              :model-value="queryParamValueOf(queryParam.name)"
              :param-name="queryParam.name"
              v-on:update-query-param-value="notifyParamChange"
            ></component>
          </template>
        </query-input-card>
      </v-container>
    </v-col>
  </v-row>
</template>

<script>
import validationMixin from '@/validators/validations_mixin'
import { DealerSelect } from '@/components/inputs'
import QueryInputCard from './QueryInputCard'
import { mapState } from 'vuex'

import {
  UnknownInput,
  NoInput,
  RangeInput,
  SelectInput,
  MultiSelectInput,
  FieldInput,
  AutocompleteInput,
  OpsCodeSearch,
  PostalCodeSearch,
  Note,
  UnitOfMeasureInput,
  ComparatorFieldInput,
  AgeComparatorFieldInput
} from './query_input_fields'

const INPUT_TYPE_COMPONENT_MAPPING = {
  [RangeInput.inputType]: RangeInput.name,
  [SelectInput.inputType]: SelectInput.name,
  [MultiSelectInput.inputType]: MultiSelectInput.name,
  [UnknownInput.inputType]: UnknownInput.name,
  [FieldInput.inputType]: FieldInput.name,
  [FieldInput.inputType]: FieldInput.name,
  [NoInput.inputType]: NoInput.name,
  [AutocompleteInput.inputType]: AutocompleteInput.name,
  [OpsCodeSearch.inputType]: OpsCodeSearch.name,
  [PostalCodeSearch.inputType]: PostalCodeSearch.name,
  [Note.inputType]: Note.name,
  [UnitOfMeasureInput.inputType]: UnitOfMeasureInput.name,
  [ComparatorFieldInput.inputType]: ComparatorFieldInput,
  [AgeComparatorFieldInput.inputType]: AgeComparatorFieldInput
}

export default {
  mixins: [validationMixin],
  props: {
    selectedQueryParams: {
      type: Array,
      required: true
    },
    queryParamValues: {
      type: Array,
      required: true
    },
    initialQueryName: {
      type: String,
      required: false,
      default: ''
    },
    initialDealerId: {
      type: [String, Number],
      required: false,
      default: ''
    }
  },
  data: function () {
    return {
      dealerId: null,
      queryName: null

    }
  },
  components: {
    [DealerSelect.name]: DealerSelect,
    [QueryInputCard.name]: QueryInputCard,
    [RangeInput.name]: RangeInput,
    [SelectInput.name]: SelectInput,
    [MultiSelectInput.name]: MultiSelectInput,
    [UnknownInput.name]: UnknownInput,
    [FieldInput.name]: FieldInput,
    [NoInput.name]: NoInput,
    [AutocompleteInput.name]: AutocompleteInput,
    [OpsCodeSearch.name]: OpsCodeSearch,
    [PostalCodeSearch.name]: PostalCodeSearch,
    [Note.name]: Note,
    [UnitOfMeasureInput.name]: UnitOfMeasureInput,
    [ComparatorFieldInput.name]: ComparatorFieldInput
  },
  computed: {
    ...mapState('ApplicationStore', ['dealerScopedView'])
  },
  watch: {
    initialDealerId: function (newDealerId, oldDealerId) {
      if (newDealerId !== oldDealerId) {
        this.dealerId = newDealerId
      }
    },
    initialQueryName: function (newQueryName, oldQueryName) {
      if (newQueryName !== oldQueryName) {
        this.queryName = newQueryName
      }
    },
    dealerId: function (newDealerId, oldDealerId) {
      if (newDealerId !== oldDealerId) {
        this.$emit('update:dealer-id', newDealerId)
      }
    },
    queryName: function (newQueryName, oldQueryName) {
      if (newQueryName !== oldQueryName) {
        this.$emit('update:query-name', newQueryName)
      }
    }
  },
  methods: {
    queryParamValueOf (queryParamName) {
      const qpValue = this.queryParamValues.find(qpv => qpv.name === queryParamName)
      const { name, ...componentProps } = qpValue // this puts all props except name into componentProps
      return componentProps
    },
    notifyRemovalOf: function (queryParamName) {
      this.$emit('remove-query-param', queryParamName)
    },
    inputTypeView (queryParam) {
      const targetInput = INPUT_TYPE_COMPONENT_MAPPING[queryParam.input_type]
      return targetInput || UnknownInput.name
    },
    notifyParamChange (eventData) {
      this.$emit('update-query-param-value', eventData)
    }
  }
}
</script>
